import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const CompanyAddressForm = ({
  address,
  company_latitude,
  company_longitude
}) => {
  const {
    setValue
  } = useFormContext();

  // Show full address selected
  useEffect(() => {
    const locationInput = document.getElementById('autocomplete');
    const autocomplete = new google.maps.places.Autocomplete(locationInput, {
      componentRestrictions: { country: ['za', 'eg'] },
      fields: ['geometry', 'formatted_address'],
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (place && place.formatted_address) {
        setValue('address', place.formatted_address, {
          shouldDirty: true
        });
        setValue('company_latitude', place.geometry.location.lat(), {
          shouldDirty: true
        });
        setValue('company_longitude', place.geometry.location.lng(), {
          shouldDirty: true
        });
      }
    });
  }, []);

  const handleChange = (e) => {
    setValue('address', e.target.value, {
      shouldDirty: true
    });
    setValue('company_latitude', null, {
      shouldDirty: true
    });
    setValue('company_longitude', null, {
      shouldDirty: true
    });
  }

  return (
    <div 
      className={`${(company_latitude == null || company_longitude == null) ? 'bg-red-300 animate-pulse rounded-md' : ''} w-full flex flex-col mb-3`}
      style={{ 
        padding: '2px'
      }}
    >
      <input
        id={`autocomplete`}
        onChange={(e)=> handleChange(e)}
        defaultValue={address}
        className={`input border text-sm py-1 rounded-lg w-full md:w-3/4 lg:w-5/6 border-gray-400 text-gray-900 px-2`}
        placeholder="Enter address"
        style={{ 
          width: '100%', 
          padding: '12px', 
          border: '1px solid #ccc', 
          borderRadius: '4px' 
        }}
      />
    </div>
  );
};

export default CompanyAddressForm;